import {Component, Input} from '@angular/core';
import {ErrorResponse} from "./interfaces/error-response";

@Component({
    selector: 'app-messages-toaster',
    templateUrl: './messages-toaster.component.html',
    styles: ``,
    standalone: false
})
export class MessagesToasterComponent {

  @Input()
  errorResponse: ErrorResponse = {
    code: "",
    message: ""
  };

  @Input()
  showToast: boolean = false;

  get alertClass(): string {
    const code = (this.errorResponse?.code || '').toUpperCase();
    switch (code) {
      case 'OK':
      case 'SUCCESS':
        return 'alert-success';
      case 'WARN':
      case 'WARNING':
        return 'alert-warning';
      case 'INFO':
        return 'alert-info';
      default:
        return 'alert-danger';
    }
  }
}
